// CarouselItem.js
import React, { useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import styles from '../styles/carouselitem.module.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { faEarthEurope, faDatabase } from "@fortawesome/free-solid-svg-icons";
import { faCss3Alt,  faHtml5, faJs, faNode, faReact, faFigma, faWix} from '@fortawesome/free-brands-svg-icons';

const CarouselItem = ({ index, currentIndex, image, mobileImage, text, link, skills, numItems }) => {
  const skillToIconMap = {
    "CSS3": <FontAwesomeIcon icon={faCss3Alt} />,
    "HTML5": <FontAwesomeIcon icon={faHtml5} />,
    "JavaScript": <FontAwesomeIcon icon={faJs} />,
    "React": <FontAwesomeIcon icon={faReact} />,
    "Figma": <FontAwesomeIcon icon={faFigma} />,
    "Node.js": <FontAwesomeIcon icon={faNode} />,
    "PostgreSQL": <FontAwesomeIcon icon={faDatabase} />,
    "Wix": <FontAwesomeIcon icon={faWix} />
  };

  const [isHovered, setIsHovered] = useState(false);

  const isMobileView = useMediaQuery({ query: '(max-width: 1000px)' });

  const getClassName = (i) => {
    const position = (i - currentIndex + numItems) % numItems;
    if (position === 0) return `${styles.container} ${styles.front}`;
    if (position === 1) return `${styles.container} ${styles.behind1}`;
    if (position === 2) return `${styles.container} ${styles.behind2}`;
    if (position === 3) return `${styles.container} ${styles.behind3}`;
    return styles.hidden;
  };

  const handleMouseEnter = () => {
    if (!isMobileView) {  // Only enable hover state on larger screens
      setIsHovered(true);
    }
  };

  const handleMouseLeave = () => {
    if (!isMobileView) {  // Only disable hover state on larger screens
      setIsHovered(false);
    }
  };

  return (
    <div className={getClassName(index)}>
      <div 
        className={styles.item}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <img src={image} alt={`item-${index}`} />
        <a href={link} target="_blank" rel="noopener noreferrer" className={styles.viewWebsite}>
          <FontAwesomeIcon style={{paddingRight: "5px"}}icon={faEarthEurope} />
          View Website
        </a>
        <a href={link} target="_blank" rel="noopener noreferrer" className={styles.smallViewWebsite}>
          <FontAwesomeIcon style={{paddingRight: "5px"}}icon={faEarthEurope} />
          View Website
        </a>
      </div>
      <div className={styles.text}>
        {isHovered ? (
          <>
          <div className={styles.mobileView} style={isHovered ? {borderRadius: "20px", width: "100%", height: "100%", backgroundImage: `url(${mobileImage})`, backgroundRepeat: "no-repeat", backgroundSize: "cover"} : {}}>
          </div>
          </>
        ) : (
          <div className={styles.textContent}>
            <h1>{text.title}</h1>
            <p>{text.description}</p>
            <div className={styles.brandContainer}>
              {skills.filter(skill => skill in skillToIconMap)
                .map((skill, index) => (
                  <React.Fragment key={index}>{skillToIconMap[skill]}</React.Fragment>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CarouselItem;
